import * as Types from './types'

export const SERVER_RESOURCE = '/users/settings'

export const FETCH_USER_SETTINGS = 'FETCH_USER_SETTINGS'
export const ADD_USER_KEY = 'ADD_USER_KEY'
export const REFRESH_USER_KEY = 'ADD_USER_KEY'

export const emptyViewState: Types.UserSettings = {
  account_email: '',
  first_name: '',
  icp_guid: '',
  id: '',
  keys: [],
  last_name: '',
  membership_email: '',
  username: '',
}

export  const emptyAddUserKeyModalState: Types.UserKeyModalData = {
  name: '',
}



// WEBPACK FOOTER //
// ./src/pages/user-settings/constants.ts